import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import Main from "./pages/main/Main";


function App() {
    return (
            <BrowserRouter>
                    <Routes>
                        <Route path="/" exact  element={<Main/>}/>
                    </Routes>
            </BrowserRouter>
    );
}

export default App;
